const getActiveBrandPromotion = (brandName, brandPromotions) => {
  if (!brandPromotions) {
    return void 0;
  }
  return brandPromotions.find(({ name }) => name.toLowerCase() === brandName.toLowerCase());
};
export {
  getActiveBrandPromotion
};
//# sourceMappingURL=get-active-brand-promotion.js.map
